import { onMounted, defineComponent, ref, watch } from 'vue';
import { VCodeService } from '@/services/vcode.service';
import { useService } from '@kaokei/use-vue-service';
import { debounce } from 'lodash-es';
export default defineComponent({
  name: 'ImageCode',
  setup: function (props, _a) {
    // 这里的验证码服务是当前组件的，而不是从父组件获取
    // declareProviders([VCodeService]);
    var emit = _a.emit;
    var vcodeService = useService(VCodeService);
    var imageUrl = ref('');
    var onClickBtn = debounce(function () {
      vcodeService.getImageCode();
    }, 240);
    onMounted(function () {
      vcodeService.getImageCode();
    });
    watch(function () {
      return vcodeService.imageCodeUrl;
    }, function (imageCodeUrl) {
      if (imageCodeUrl) {
        imageUrl.value = imageCodeUrl;
        emit('clearCode');
      }
    });
    return {
      imageUrl: imageUrl,
      onClickBtn: onClickBtn,
      vcodeService: vcodeService
    };
  }
});